import { authGet, authGetConditional, authPost, type ConditionalResponse } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type {
  DailyChallengeCompleteDto,
  DailyChallengeLevelDto,
  DailyChallengePayloadDto,
} from "../dto/daily_challenge.dto.js";

const DAILY_CHALLENGE_PATH = "api/player/me/daily-challenge?include_locked=1";

export function getDailyChallenge(): Promise<DailyChallengePayloadDto>
{
  const primed = PrimedResponses.take<DailyChallengePayloadDto>( "daily_challenge" );
  if ( primed ) return Promise.resolve( primed );
  return authGet<DailyChallengePayloadDto>( DAILY_CHALLENGE_PATH );
}

export function getDailyChallengeConditional( etag: string | null ): Promise<ConditionalResponse<DailyChallengePayloadDto>>
{
  const primed = PrimedResponses.take<DailyChallengePayloadDto>( "daily_challenge" );
  if ( primed )
    return Promise.resolve( { status: 200, data: primed, etag: PrimedResponses.take<string | null>( "daily_challenge_etag" ) ?? null } );
  return authGetConditional<DailyChallengePayloadDto>( DAILY_CHALLENGE_PATH, etag );
}

export function getDailyChallengeLevel( stage: number ): Promise<DailyChallengeLevelDto>
{
  return authGet<DailyChallengeLevelDto>( `api/player/me/daily-challenge/level/${stage}?include_locked=1` );
}

export function completeDailyChallengeStage( stage: number ): Promise<DailyChallengeCompleteDto>
{
  return authPost<DailyChallengeCompleteDto>( `api/player/me/daily-challenge/${stage}/complete` );
}
